import SegurancaApiInterceptor from '@finx/web-repository/src/apis/Seguranca/SegurancaApiInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import { UsuarioSegurancaPermissoes } from '@/types/interfaces/UsuarioDiagnostico'
import { buildQueryParams } from '@/utils/common'

const api = new SegurancaApiInterceptor()
const factory = new FactoryResponse()

export default {
  async getByLogin(login: string) {
    const result = await api.getAllowAnonymous(`usuarios/login/${login}`)
    return factory.build(result)
  },

  // FXCS-4128 - Diagnostico de Usuario
  async getById(id: string) {
    const result = await api.get(`usuarios/${id}`)
    return factory.build(result)
  },

  async getPermissoesById(id: string): Promise<ResponseApi<UsuarioSegurancaPermissoes>> {
    const result = await api.get(`usuarios/${id}/roles`)
    return factory.build<UsuarioSegurancaPermissoes>(result)
  },

  async getDiagnosticoKeycloak(params: { id?: string; email?: string }) {
    const result = await api.get(`usuarios/keycloak/diagnostico?${buildQueryParams(params)}`)
    return factory.build(result)
  },
}
